import { Row, Spin } from 'antd';

const FullPageLoader = (): JSX.Element => {
    return (
        <Row justify="center" align="middle" style={{ height: '100vh' }}>
            <Spin size="large" />
        </Row>
    );
};

export default FullPageLoader;
